import POSITION_ANALYSE_ACTION_TYPES, {
  PositionAnalyseActionTypes,
} from 'actionTypes/positionAnalyse';
import { BASKET_ANALYTICS_API } from 'constants/api';
import { OpenPosition } from 'types/IOpenPosition';
import { PositionAnalyticsRequestPayload } from 'types/positionAnalyse';

import { authAction } from './user';

const getPositionAnalytics = ({
  payload,
  options,
}: {
  payload: PositionAnalyticsRequestPayload;
  // TO re-check: separate this a different action because of the delay of response
  options: {
    isAnalyticsApiRefetching?: boolean;
    requestedTargetPrice?: number;
  };
}) => {
  return authAction({
    types: POSITION_ANALYSE_ACTION_TYPES[PositionAnalyseActionTypes.POSITION_ANALYTICS],
    promise: ({ request }) =>
      request.post(BASKET_ANALYTICS_API.GET_BASKET_ANALYTICS, {
        data: payload,
      }),
    options,
  });
};

const setPositionAnalyseLoading = (payload: boolean) => {
  return {
    type: PositionAnalyseActionTypes.POSITION_ANALYSE_LOADING,
    payload,
  };
};

const addPositionToAnalyze = (payload: any) => {
  return {
    type: PositionAnalyseActionTypes.ADD_PRODUCT_TO_ANALYZE,
    payload,
  };
};

const removeAllPositionFromAnalyze = () => {
  return {
    type: PositionAnalyseActionTypes.REMOVE_ALL_PRODUCT_FROM_ANALYZE,
  };
};

const setOpenPositionsForAnalysis = (payload: OpenPosition[]) => {
  return {
    type: PositionAnalyseActionTypes.SET_POSITIONS,
    payload,
  };
};

const setPositionAnalyticsModalToggleState = (payload: boolean) => {
  return {
    type: PositionAnalyseActionTypes.UPDATE_MODAL_STATE,
    payload,
  };
};

const setPositionAnalyticsPnlTabTargetDate = (payload: {
  selectedPnlTableTargetDate: number;
  selectedPnlTableTargetDateIndex: number;
}) => {
  return {
    type: PositionAnalyseActionTypes.POSITION_ANALYTICS_PNL_TAB_SELECTED_TARGET_DATE,
    payload,
  };
};

const setPositionAnalyticsPnlTabSelectedRows = (payload: {
  selectedRowIds: number[];
  targetDateMax: number;
  selectedTargetDate: number;
}) => {
  return {
    type: PositionAnalyseActionTypes.POSITION_ANALYZE_PNL_TABLE_TAB_SELECTED_ROWS,
    payload,
  };
};

const setPositionAnalyticsPnlTabTargetPrice = (payload: number) => {
  return {
    type: PositionAnalyseActionTypes.POSITION_ANALYTICS_PNL_TAB_SELECTED_TARGET_PRICE,
    payload,
  };
};

const { POSITION_ANALYTICS_PNL_TAB_LAST_RESOLVED_TARGET_PRICE } =
  PositionAnalyseActionTypes;

const setPositionAnalyticsPnlTabLastResolvedTargetPrice = (payload: number) => {
  return {
    type: POSITION_ANALYTICS_PNL_TAB_LAST_RESOLVED_TARGET_PRICE,
    payload,
  };
};

const setPositionAnalyticsInitiallySelectedPositionIds = (payload: number[]) => {
  return {
    type: PositionAnalyseActionTypes.POSITION_ANALYTICS_INITIALLY_SELECTED_POSITION_IDS,
    payload,
  };
};

const resetPositionAnalytics = () => {
  return {
    type: PositionAnalyseActionTypes.RESET_POSITION_ANALYTICS,
  };
};

export {
  addPositionToAnalyze,
  getPositionAnalytics,
  removeAllPositionFromAnalyze,
  setOpenPositionsForAnalysis,
  setPositionAnalyseLoading,
  setPositionAnalyticsModalToggleState,
  setPositionAnalyticsPnlTabSelectedRows,
  setPositionAnalyticsPnlTabTargetDate,
  setPositionAnalyticsPnlTabTargetPrice,
  setPositionAnalyticsPnlTabLastResolvedTargetPrice,
  setPositionAnalyticsInitiallySelectedPositionIds,
  resetPositionAnalytics,
};
